<template>
  <div class="jm-empty">
    <!-- 空状态图片 slot image -->
    <div class="jm-empty__image" :style="imageStyle">
      <img v-if="image" :src="image" ondragstart="return false">
      <slot v-else name="image">
        <img src="@/assets/images/icon-nodata.png" />
      </slot>
    </div>
    <!-- 描述文字 slot  description -->
    <div class="jm-empty__description">
      <slot v-if="$slots.description" name="description"></slot>
      <p v-else>{{ emptyDescription }}</p>
    </div>
    <!-- 底部内容 匿名插槽-->
    <div v-if="$slots.default" class="jm-empty__bottom">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Empty',
  props: {
    // 图片URL
    image: {
      type: String,
      default: ''
    },
    // 设定图片宽度
    imageSize: {
      type: Number,
    },
    // 文本描述
    description: {
      type: String,
      default: ''
    }
  },
  computed: {
    emptyDescription() {
      return this.description || '暂无数据';
    },
    imageStyle() {
      return {
        width: this.imageSize ? `${this.imageSize}px` : ''
      };
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.jm-empty{
  background: #fff;
  border-radius: 14px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  box-sizing: border-box;
  padding: 40px 0;
}
.jm-empty__description {
  color:#8b8b8b;
}
.jm-empty__image img{
  width:100%;height: 100%;
}
</style>
